import { useNavigate } from 'react-router-dom';
import { getPreviusApplicationProgressRoute, removeApplicationProgressRoute } from '@utils/localStorage';

export const useNavigateBack = () => {
  const navigate = useNavigate();

  const navigateBack = () => {
    const previousPage = getPreviusApplicationProgressRoute();

    removeApplicationProgressRoute();
    navigate(previousPage);
  };

  return navigateBack;
};
